module.exports = __webpack_public_path__ + "img/抱拳.3ae1c706.gif";